import { useParams } from 'react-router-dom'
import Button from '../../../../../components/common/Button'
import NoRecordsFound from '../../../../../components/common/NoRecordsFound'
import {
  deleteRequest,
  getRequest,
  postRequest,
} from '../../../../../services/base'
import DtcDependencyRow from './DtcDependencyRow'
import DtcDependencyForm from './form'
import { useContext, useEffect, useState } from 'react'
import { DtcDependencyContext, SHOW_DEPENDENCY_MODAL } from '../context/context'
import { NavContext } from '../../../../../context/global_context'

const DtcDependencies = (props) => {
  let { dtc_id, vehicle } = useParams()
  const [state, dispatch] = useContext(DtcDependencyContext)
  const [navState, navDispatch] = useContext(NavContext)

  const [dependentDtcs, setDependentDtcs] = useState([])

  useEffect(() => {
    getDependentDtc()
  }, [])

  const getDependentDtc = async () => {
    let res = await getRequest(
      `/api/dtcs/dependent_dtcs/${dtc_id}/?vehicle=${vehicle}`
    )
    setDependentDtcs(res.data)
  }

  const SubmitDependentDtc = async (e) => {
    const form = e.target
    const formData = new FormData(form)
    formData.append('vehicle', vehicle)
    let res = await postRequest(
      `/api/dtcs/save_dependent_dtcs/${dtc_id}/`,
      formData
    )
    dispatch({ type: SHOW_DEPENDENCY_MODAL, data: false })
    navDispatch({
      type: 'notification',
      data: {
        notification_type: 'success',
        msg: `Dependent Dtc Added Successfully`,
      },
    })
    getDependentDtc()
  }

  const onDelete = async (element) => {
    if (window.confirm(`Are you sure want to delete ${element.name}`) == true) {
      let res = await deleteRequest(
        `/api/dtcs/delete_dependent_dtcs/${element.id}/`
      )
      if (res.status) {
        let tempDtcs = [...dependentDtcs]
        const newDtc = tempDtcs.filter((d) => d.id !== element.id)
        setDependentDtcs(newDtc)
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: `Dependent Dtc Deleted Successfully`,
          },
        })
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res.msg,
          },
        })
      }
    }
  }

  return (
    <>
      <DtcDependencyForm
        SubmitDependentDtc={(e) => {
          SubmitDependentDtc(e)
        }}
      />
      <div className="w-full px-12 mb-4">
        <div className="flex justify-between content-center items-center">
          <div className="font-bold text-xl py-3">Dtc's Dependencies</div>
          <Button
            type="submit"
            className={`cursor-pointer cursor-pointer btn my-4 px-5`}
            onClick={(e) => {
              dispatch({ type: SHOW_DEPENDENCY_MODAL, data: true })
            }}
            value={'text'}
            text="Add New Dependency"
          />
        </div>

        <div className="font-light">
          <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
            <div className="flex w-4/12 pl-10 items-center">DTC Name</div>
            <div className="flex w-4/12 pl-6 items-center">Description</div>
            <div className="flex w-3/12 pl-6 items-center">ECU</div>
            <div className="flex w-1/12 pl-6 items-center"></div>
          </div>
        </div>
        {dependentDtcs?.length > 0 ? (
          dependentDtcs.map((row, index) => {
            return (
              <DtcDependencyRow
                {...row}
                onDelete={() => {
                  onDelete(row)
                }}
                key={`dtc-dependencies-${row.id}`}
              />
            )
          })
        ) : (
          <NoRecordsFound />
        )}
      </div>
    </>
  )
}

export default DtcDependencies
